import { getEnvConfig } from "@/config/environments";

const appEnv = getEnvConfig().appEnv;
export const IS_PROD = !["LOCAL", "DEV", "QA", "PLAY", "TEST", "UAT", "DEMO", "DEMO-V2", "RAZVAN", "IOAN"].some(
  (suffix) => appEnv.toLowerCase().endsWith(suffix.toLowerCase())
);

export const isDev = appEnv === "DEV" || process.env.NODE_ENV === "development";
